// src/hooks/useScrollToTop.js
import { useEffect } from 'react';

export default function useScrollToTop(trigger) {
  useEffect(() => {
    // Small delay to ensure DOM is updated before scrolling
    const scrollTimer = setTimeout(() => {
      //console.log('[useScrollToTop] Scrolling to top triggered by:', trigger);
      
      // First, try to find all potentially scrollable containers
      const containers = [
        document.querySelector('.content-with-nav'),
        document.querySelector('.content-full'),
        document.querySelector('.practice-test-content-area'),
        document.querySelector('.practice-test'),
        document.documentElement,
        document.body
      ].filter(Boolean); // Remove null/undefined elements
      
      //console.log('[useScrollToTop] Found containers:', containers.map(c => c.className || c.tagName));
      
      // Try to scroll each container that might be scrollable
      containers.forEach((container, index) => {
        try {
          if (container.scrollTo) {
            container.scrollTo({ top: 0, left: 0, behavior: 'auto' });
            //console.log(`[useScrollToTop] Scrolled container ${index}:`, container.className || container.tagName);
          } else {
            container.scrollTop = 0;
            //console.log(`[useScrollToTop] Set scrollTop=0 for container ${index}:`, container.className || container.tagName);
          }
        } catch (e) {
          //console.log(`[useScrollToTop] Failed to scroll container ${index}:`, e.message);
        }
      });
      
      // Also try window scroll as final fallback
      try {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        //console.log('[useScrollToTop] Window scrolled');
      } catch (e) {
        window.scrollTo(0, 0);
        //console.log('[useScrollToTop] Window scrolled (fallback)');
      }
      
      //console.log('[useScrollToTop] Scroll operation completed');
    }, 50); // 50ms delay to ensure DOM is ready
    
    return () => clearTimeout(scrollTimer);
  }, [trigger]);
}
